export const uiToggleSkin = () => {
  document.body.classList.toggle("light-mode");
  if (document.body.classList.contains("light-mode")) {
    localStorage.setItem("lightMode", "1");
  } else {
    localStorage.removeItem("lightMode");
  }
};
